import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import colorSharp2 from "./img/color-sharp2.png";
import 'animate.css';
import TrackVisibility from 'react-on-screen';
import projectsData from "../../assets/data/projects.json"; //Projects data
import './Project.css';

export const Projects = () => {
  // console.log(projectsData);
  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                  <h2>Projects</h2>
                  <p>List of my personal and university projects throughout the years.<br></br> Hover over them to read more!</p>
                  <Tab.Container id="projects-tabs" defaultActiveKey="first">
                    <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                      <Nav.Item>
                        <Nav.Link eventKey="first">2021</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="second">2022</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="third">2023</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="fourth">2024</Nav.Link>
                      </Nav.Item>
                    </Nav>
                    <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                      <Tab.Pane eventKey="first">
                        <Row>
                          {
                            projectsData.projects_2021.map((project, index) => {
                              return (
                                <ProjectCard key={index} {...project} />
                              )
                            })
                          }
                        </Row>

                      </Tab.Pane>

                      <Tab.Pane eventKey="second">
                        <Row>
                          {
                            projectsData.projects_2022.map((project, index) => {
                              return (
                                <ProjectCard key={index} {...project} />
                              )
                            })
                          }
                        </Row>
                      </Tab.Pane>

                      <Tab.Pane eventKey="third">
                        <Row>
                          {
                            projectsData.projects_2023.map((project, index) => {
                              return (
                                <ProjectCard key={index} {...project} />
                              )
                            })
                          }
                        </Row>
                      </Tab.Pane>

                      <Tab.Pane eventKey="fourth">
                        <Row>
                          {
                            projectsData.projects_2024.map((project, index) => {
                              return (
                                <ProjectCard key={index} {...project} />
                              )
                            })
                          }
                        </Row>
                      </Tab.Pane>
                    </Tab.Content>
                  </Tab.Container>
                </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" alt="img" src={colorSharp2}></img>
    </section>
  )
}
